/* Northern Auto Parts — product page conversion layer (v3)
   1. Live dispatch cut-off (HH:MM:SS to 12:00 Europe/London, Mon–Fri, England bank holidays) + delivery dates
   2. Copy-to-clipboard (reference-number pills, LAUNCH10 code)
   3. Mobile sticky add-to-cart bar (with live dispatch line)
   4. Pair offer buttons (add 2 / add both sides) through the theme's cart drawer
   5. Post-add-to-cart upsell modal (other side / second unit) — triggered by the real add-to-cart request
   6. Welcome-offer popup (LAUNCH10), once per 7 days, exit-intent on desktop, timed/scroll on mobile
*/
(function () {
  'use strict';

  /* ---------------- 1. dispatch & delivery ---------------- */
  var CUTOFF_HOUR = 12; // noon, Europe/London
  var BANK_HOLIDAYS = [
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25', '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'
  ];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function londonNow() {
    try {
      var f = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      var p = {};
      f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second));
    } catch (e) {
      var d = new Date();
      return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()));
    }
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isWorking(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && BANK_HOLIDAYS.indexOf(iso(d)) === -1; }
  function startOfDay(d) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function addWorking(d, n) { var x = startOfDay(d); while (n > 0) { x = addDays(x, 1); if (isWorking(x)) n--; } return x; }
  function isDeliveryDay(d) { return d.getUTCDay() !== 0 && BANK_HOLIDAYS.indexOf(iso(d)) === -1; } // Royal Mail delivers Mon–Sat
  function addDelivery(d, n) { var x = startOfDay(d); while (n > 0) { x = addDays(x, 1); if (isDeliveryDay(x)) n--; } return x; }
  function fmt(d) { return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; }
  function isTomorrow(d, now) { return iso(d) === iso(addDays(startOfDay(now), 1)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var dispatchState = { hot: false, clock: '' };

  function renderDispatch() {
    var el = document.querySelector('[data-nap-dispatch]');
    var now = londonNow();
    var cutoff = new Date(startOfDay(now).getTime() + CUTOFF_HOUR * 3600 * 1000);
    var hotNow = isWorking(now) && now < cutoff;
    var dispatch;
    if (hotNow) {
      dispatch = startOfDay(now);
      var ms = cutoff - now;
      var h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000), s = Math.floor((ms % 60000) / 1000);
      dispatchState.clock = pad(h) + ':' + pad(m) + ':' + pad(s);
    } else {
      dispatch = addWorking(now, 1);
      dispatchState.clock = '';
    }
    dispatchState.hot = hotNow;
    if (!el) return;
    var hot = el.querySelector('[data-nap-hot]');
    var next = el.querySelector('[data-nap-next]');
    var timer = el.querySelector('[data-nap-timer]');
    var nextDay = el.querySelector('[data-nap-next-day]');
    var std = el.querySelector('[data-nap-std]');
    var exp = el.querySelector('[data-nap-exp]');
    if (hotNow) {
      if (timer) timer.textContent = dispatchState.clock;
      if (hot) hot.hidden = false;
      if (next) next.hidden = true;
    } else {
      if (nextDay) nextDay.textContent = isTomorrow(dispatch, now) ? 'tomorrow (' + fmt(dispatch) + ')' : fmt(dispatch);
      if (hot) hot.hidden = true;
      if (next) next.hidden = false;
    }
    if (!el.classList.contains('is-ready')) {
      // Owner's delivery promise: Standard 2–3 days (free), Express 1–2 days
      var s1 = addDelivery(dispatch, 2), s2 = addDelivery(dispatch, 3);
      var e1 = addDelivery(dispatch, 1), e2 = addDelivery(dispatch, 2);
      if (std) std.textContent = fmt(s1) + ' – ' + fmt(s2);
      if (exp) exp.textContent = fmt(e1) + ' – ' + fmt(e2);
      el.classList.add('is-ready');
      el.setAttribute('data-nap-dispatch-day', iso(dispatch));
    } else if (el.getAttribute('data-nap-dispatch-day') !== iso(dispatch)) {
      el.classList.remove('is-ready'); // day rolled over while the page was open — recompute
      renderDispatch();
    }
  }

  /* ---------------- 2. copy buttons ---------------- */
  function initCopy() {
    document.querySelectorAll('[data-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-copy');
        var done = function () {
          btn.classList.add('is-copied');
          var label = btn.querySelector('[data-copy-label]');
          var orig = label ? label.textContent : '';
          if (label) label.textContent = 'Copied';
          setTimeout(function () { btn.classList.remove('is-copied'); if (label) label.textContent = orig; }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(done, done);
        else done();
      });
    });
  }

  /* ---------------- 2b. collapsed reference pills ---------------- */
  function initPillsMore() {
    document.querySelectorAll('[data-nap-pills-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wrap = b.closest('[data-nap-pills]');
        if (wrap) wrap.classList.remove('is-collapsed');
        b.setAttribute('aria-expanded', 'true');
      });
    });
  }

  /* ---------------- cart helpers (Dawn cart drawer / notification) ---------------- */
  function cartEl() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }
  function cartAddUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add'; }

  var napAdding = false; // marks our own add requests so the upsell interceptor ignores them
  function addItems(items) {
    var cart = cartEl();
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    napAdding = true;
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (json) {
      napAdding = false;
      if (json && json.status && json.status !== 200 && json.description) throw new Error(json.description);
      if (cart && typeof cart.renderContents === 'function' && json && json.sections) {
        try { cart.renderContents(json); } catch (e) { window.location.href = '/cart'; }
      } else {
        window.location.href = '/cart';
      }
      return json;
    }).catch(function (e) { napAdding = false; if (window.console) console.error('NAP add to cart failed', e); });
  }

  /* ---------------- 3. sticky add-to-cart ---------------- */
  function initSticky() {
    var bar = document.getElementById('nap-sticky');
    if (!bar) return;
    document.body.appendChild(bar);
    var mainBtn = document.querySelector('product-info .product-form__submit') || document.querySelector('.product-form__submit');
    if (!mainBtn) return;
    var btn = bar.querySelector('.nap-sticky__btn');
    var price = bar.querySelector('.nap-sticky__price');
    var line = bar.querySelector('[data-nap-sticky-line]');
    var origLine = line ? line.textContent : '';

    function syncState() {
      var disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      btn.disabled = disabled;
      var label = mainBtn.querySelector('span');
      if (label && label.textContent.trim()) btn.textContent = label.textContent.trim();
      var live = document.querySelector('product-info .price__regular .price-item, product-info .price-item--sale');
      if (live && price) { var low = price.querySelector('.nap-sticky__low'); price.textContent = live.textContent.trim(); if (low) price.appendChild(low); }
    }
    function syncLine() {
      if (!line) return;
      if (dispatchState.hot) { line.textContent = 'Order in ' + dispatchState.clock + ' → dispatched today'; line.classList.add('is-live'); }
      else { line.textContent = origLine; line.classList.remove('is-live'); }
    }
    syncState(); syncLine();
    setInterval(syncLine, 1000);

    btn.addEventListener('click', function () { if (!btn.disabled) mainBtn.click(); });

    var show = function (v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      btn.tabIndex = v ? 0 : -1;
      document.body.classList.toggle('nap-sticky-open', v);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { show(!entries[0].isIntersecting); }, { rootMargin: '0px 0px -10% 0px' });
      io.observe(mainBtn);
    } else { show(true); }
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncState, 50); });
    }
    new MutationObserver(function () { syncState(); }).observe(mainBtn, { attributes: true, childList: true, subtree: true });
  }

  /* ---------------- 4. pair offer buttons ---------------- */
  function initPairButtons() {
    document.querySelectorAll('[data-nap-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var items = b.getAttribute('data-variants').split(',').map(function (p) {
          var x = p.split(':'); return { id: parseInt(x[0], 10), quantity: parseInt(x[1] || '1', 10) };
        });
        b.disabled = true; var t = b.textContent; b.textContent = 'Adding…';
        addItems(items).then(function () { b.disabled = false; b.textContent = t; });
      });
    });
  }

  /* ---------------- 5. post-add-to-cart upsell ---------------- */
  var upsellShownOnce = false;
  function showUpsell() {
    var modal = document.getElementById('nap-upsell');
    var data = document.querySelector('[data-nap-pair]');
    if (!modal || !data || upsellShownOnce) return;
    var kind = data.getAttribute('data-upsell-kind');
    var pct = data.getAttribute('data-upsell-pct') || '7';
    modal.querySelector('[data-nap-upsell-heading]').textContent = kind === 'other-side' ? 'Doing both sides? Add the other one' : 'Doing both sides? Add a second one';
    modal.querySelector('[data-nap-upsell-name]').textContent = data.getAttribute('data-upsell-title');
    modal.querySelector('[data-nap-upsell-price]').textContent = data.getAttribute('data-upsell-price');
    modal.querySelector('[data-nap-upsell-pct]').textContent = pct + '% off both';
    var img = modal.querySelector('[data-nap-upsell-img]');
    img.src = data.getAttribute('data-upsell-image') || '';
    var addBtn = modal.querySelector('[data-nap-upsell-add]');
    addBtn.textContent = 'Add it — ' + pct + '% off both';
    addBtn.onclick = function () {
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      addItems([{ id: parseInt(data.getAttribute('data-upsell-variant'), 10), quantity: 1 }]).then(function () { closeUpsell(); });
    };
    document.body.appendChild(modal);
    modal.hidden = false;
    document.body.classList.add('nap-modal-open');
    upsellShownOnce = true;
  }
  function closeUpsell() {
    var modal = document.getElementById('nap-upsell');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('nap-modal-open');
  }
  function initUpsell() {
    var modal = document.getElementById('nap-upsell');
    if (!modal || !document.querySelector('[data-nap-pair]')) return;
    modal.querySelectorAll('[data-nap-upsell-close]').forEach(function (c) { c.addEventListener('click', closeUpsell); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeUpsell(); });
    // Watch the theme's own add-to-cart request (Dawn product-form → fetch routes.cart_add_url)
    var origFetch = window.fetch;
    if (!origFetch) return;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(window, arguments);
      if (!napAdding && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) {
          if (!res.ok) return;
          try {
            res.clone().json().then(function (json) {
              if (json && json.status && json.status !== 200) return; // Dawn's error payload (e.g. out of stock)
              setTimeout(showUpsell, 450);
            }).catch(function () {});
          } catch (e) {}
        }).catch(function () {});
      }
      return p;
    };
  }

  /* ---------------- 6. welcome-offer popup ---------------- */
  function initPopup() {
    var pop = document.getElementById('nap-popup-form');
    if (!pop) return;
    document.body.appendChild(pop);
    var KEY = 'nap_popup_seen';
    var posted = !!pop.querySelector('[data-nap-popup-posted]');
    var open = function () {
      if (document.body.classList.contains('nap-modal-open')) return;
      pop.classList.add('is-open');
      document.body.classList.add('nap-modal-open');
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    };
    var close = function () { pop.classList.remove('is-open'); document.body.classList.remove('nap-modal-open'); };
    pop.querySelectorAll('[data-nap-popup-close]').forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    if (posted) { open(); return; }
    var seen = 0;
    try { seen = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    if (seen && Date.now() - seen < 7 * 24 * 3600 * 1000) return;

    var armed = true;
    var fire = function () { if (!armed) return; armed = false; open(); };
    var isTouch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
    if (isTouch || window.innerWidth < 990) {
      setTimeout(fire, 25000);
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h > 0.5) { window.removeEventListener('scroll', onScroll); fire(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      setTimeout(function () {
        document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) fire(); });
      }, 4000);
      setTimeout(fire, 60000);
    }
  }

  /* ---------------- 8. cart drawer reassurance strip (v3.4) ----------------
     Dawn's drawer re-renders its inner HTML on every cart change, so the strip is re-injected
     from a MutationObserver. Text mirrors the product page: delivery, dispatch cut-off, returns. */
  function isGB() {
    var c = (window.Shopify && window.Shopify.country) || document.documentElement.getAttribute('data-nap-country') || '';
    return String(c).toUpperCase() === 'GB';
  }
  function cartDispatchHtml() {
    return dispatchState.hot
      ? 'Order in <b>' + dispatchState.clock + '</b> for same-day dispatch'
      : 'Dispatched <b>next working day</b>';
  }
  function injectCartStrip() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.querySelector('[data-nap-cart-strip]')) return;
    var footer = d.querySelector('.drawer__footer');
    if (!footer || d.classList.contains('is-empty')) return;
    var html = '<div class="nap-cart-strip" data-nap-cart-strip>' +
      '<span class="nap-cart-strip__item"><span><b>' + (isGB() ? 'Free UK delivery' : 'Ships from the UK') + '</b></span></span>' +
      '<span class="nap-cart-strip__item nap-cart-strip__item--wide"><span data-nap-cart-dispatch>' + cartDispatchHtml() + '</span></span>' +
      
      '<span class="nap-cart-strip__item"><span>Secure checkout</span></span>' +
      '</div>';
    footer.insertAdjacentHTML('afterbegin', html);
  }
  function initCartStrip() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    injectCartStrip();
    new MutationObserver(function () { injectCartStrip(); }).observe(d, { childList: true, subtree: true });
    setInterval(function () {
      var t = d.querySelector('[data-nap-cart-dispatch]');
      if (t) { var h = cartDispatchHtml(); if (t.innerHTML !== h) t.innerHTML = h; }
    }, 1000);
  }

  function init() {
    renderDispatch();
    setInterval(renderDispatch, 1000);
    initCartStrip();
    initCopy();
    initPillsMore();
    initSticky();
    initPairButtons();
    initUpsell();
    initPopup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
